   /*=========================================================================================
  File Name: mutations.js
  Description: Payment State Module
  ----------------------------------------------------------------------------------------
  Item Name: Fuji Sushi App
  Author: Tan Tran
==========================================================================================*/

export default {
    
    SET_CHECKOUT_ACCEPT_STATE (state, payload) {

        state.orderConfirmation.orderId = payload.orderId;
        state.orderConfirmation.transactionId = payload.transactionId;
        state.orderConfirmation.pickupNumber = payload.pickupNumber;
        state.orderConfirmation.pickupTime = payload.pickupTime;
        state.orderConfirmation.restaurantId = payload.restaurantId;
        state.orderConfirmation.createdDate = payload.createdDate;
        state.orderConfirmation.paymentType = payload.paymentType
        state.orderConfirmation.orderDetails = payload.orderDetails; //Order Details
        state.orderConfirmation.restaurantName = payload.restaurantName;
        state.orderConfirmation.phoneNumber = payload.phoneNumber;
        state.orderConfirmation.organizationNo = payload.organizationNumber;
        state.orderConfirmation.address = payload.address;
        state.orderConfirmation.postNumber = payload.postNumber;
        state.orderConfirmation.city = payload.city;
        
    },
 
    SET_NETS_CHECKOUT_ACCEPT_STATE (state, payload) {
        state.orderConfirmation.orderId = payload.orderId;
        state.orderConfirmation.transactionId = payload.transactionId;
        state.orderConfirmation.pickupNumber = payload.pickupNumber;
        state.orderConfirmation.pickupTime = payload.pickupTime;
        state.orderConfirmation.restaurantId = payload.restaurantId;
        state.orderConfirmation.createdDate = payload.createdDate;
        state.orderConfirmation.paymentType = payload.paymentType
        state.orderConfirmation.orderDetails = payload.orderDetails; //Order Details
        state.orderConfirmation.restaurantName = payload.restaurantName;
        state.orderConfirmation.phoneNumber = payload.phoneNumber;
        state.orderConfirmation.organizationNo = payload.organizationNumber;
        state.orderConfirmation.address = payload.address;
        state.orderConfirmation.postNumber = payload.postNumber;
        state.orderConfirmation.city = payload.city;
    },

    SET_SESSION_TOKEN_STATE(state, payload) {
        state.sessionToken = payload;
    },

    SET_NETS_SESSION_TOKEN_STATE(state, payload) {
        state.netsCheckoutOption = {
            checkoutKey: payload.checkoutKey,
            paymentId : payload.sessionToken,
            orderId : payload.orderId,
            containerId : "payment-container",
            language: "nb-NO",
            theme: {
              buttonRadius: "5px"
            }
        },
        state.sessionToken = payload.sessionToken;
    },

    SET_CHARGED_AMOUNT_STATE(state, payload) {
        state.chargedAmount = payload.chargedAmount;
        //console.log(state.chargedAmount)
    },



    SET_PAYMENT_STATE(state, payload) {
        state.sessionToken = payload.sessionToken;
        state.paymentLink = payload.paymentLink
    },

    CLEAR_PAYMENT_SESSION_STATE(state, payload) {
        state.sessionToken = '';
        state.paymentLink = '';
        state.netsCheckoutOption = null;
    },

    SET_NETS_PAYMENT_INFO_STATE(state, payload) {
        
        
    }


}